var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#956D84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2344 8.00891C13.4521 8.00891 9.86042 7.67245 8.48854 11.1933C7.92188 12.6475 8.00417 14.536 8.00417 17.2402C8.00417 19.6131 7.92813 21.8433 8.48854 23.286C9.85729 26.8089 13.4781 26.4714 17.2323 26.4714C20.8542 26.4714 24.5885 26.8485 25.9771 23.286C26.5448 21.8172 26.4615 19.9568 26.4615 17.2402C26.4615 13.6339 26.6604 11.3058 24.9115 9.55787C23.1406 7.78703 20.7458 8.00891 17.2302 8.00891H17.2344ZM17 9.5C24 9.5 25.5 9 25 21C24.5 25 21.2058 25.2111 17.2344 25.2111C10.2782 25.2111 9.30021 24.5 9.14849 17.2402C8.97629 9 11.5 9.5 17 9.5ZM22.1615 11.2047C21.55 11.2047 21.0542 11.7006 21.0542 12.312C21.0542 12.9235 21.55 13.4193 22.1615 13.4193C22.7729 13.4193 23.2688 12.9235 23.2688 12.312C23.2688 11.7006 22.7729 11.2047 22.1615 11.2047ZM17.2344 12.4995C14.6167 12.4995 12.4948 14.6225 12.4948 17.2402C12.4948 19.8579 14.6167 21.9797 17.2344 21.9797C19.8521 21.9797 21.9729 19.8579 21.9729 17.2402C21.9729 14.6225 19.8521 12.4995 17.2344 12.4995ZM17.2344 14.1631C21.3021 14.1631 21.3073 20.3172 17.2344 20.3172C13.1677 20.3172 13.1615 14.1631 17.2344 14.1631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.c545ecf4d59efa63879d2a2051f861d0.svg";
export { ForwardRef as ReactComponent };